import { PermissionEnum, UserRoleEnum } from 'api/enums';

export const ADMIN_PERMISSIONS = Object.values(PermissionEnum);

export const EDITOR_PERMISSIONS = [
    PermissionEnum.PROJECT_READ,
    PermissionEnum.PROJECT_CREATE,
    PermissionEnum.PROJECT_UPDATE,
    PermissionEnum.PROJECT_DELETE,

    PermissionEnum.PROJECT_REPORT_READ,
    PermissionEnum.PROJECT_REPORT_CREATE,
    PermissionEnum.PROJECT_REPORT_UPDATE,
    PermissionEnum.PROJECT_REPORT_DELETE,

    PermissionEnum.CAMERA_READ,
    PermissionEnum.CAMERA_CREATE,
    PermissionEnum.CAMERA_UPDATE,

    PermissionEnum.CAMERA_CCTV_READ,
    PermissionEnum.CAMERA_CCTV_CREATE,
    PermissionEnum.CAMERA_CCTV_UPDATE,

    PermissionEnum.DRONE_READ,
    PermissionEnum.DRONE_CREATE,
    PermissionEnum.DRONE_UPDATE,
    // PermissionEnum.DRONE_DELETE,
    PermissionEnum.DRONE_SHARE,

    PermissionEnum.SITE_GALLERY_READ,
    PermissionEnum.SITE_GALLERY_CREATE,
    PermissionEnum.SITE_GALLERY_UPDATE,
    // PermissionEnum.SITE_GALLERY_DELETE,
    PermissionEnum.SITE_GALLERY_SHARE,

    PermissionEnum.USER_READ,
    PermissionEnum.USER_UPDATE,
    // PermissionEnum.USER_DELETE,

    PermissionEnum.USER_INVITATION_READ,
    // PermissionEnum.USER_INVITATION_WRITE,
    // PermissionEnum.USER_INVITATION_DELETE,

    PermissionEnum.LIVELAPSE_READ,
    PermissionEnum.LIVELAPSE_CREATE,
    PermissionEnum.LIVELAPSE_UPDATE,
    // PermissionEnum.LIVELAPSE_DELETE,

    PermissionEnum.MULTIIMAGE_READ,
    PermissionEnum.MULTIIMAGE_CREATE,
    PermissionEnum.MULTIIMAGE_UPDATE,
    // PermissionEnum.MULTIIMAGE_DELETE,

    PermissionEnum.PROGRESSLINE_READ,
    PermissionEnum.PROGRESSLINE_CREATE,
    // PermissionEnum.PROGRESSLINE_DELETE,

    PermissionEnum.CAMERA_COMPARE_READ,

    PermissionEnum.PROGRESS_SLIDER_READ,

    PermissionEnum.CAMERA_INTEGRATION_READ,
    // PermissionEnum.CAMERA_INTEGRATION_WRITE,
    // PermissionEnum.CAMERA_INTEGRATION_DELETE,

    PermissionEnum.CAMERA_REPORT_READ,
    PermissionEnum.CAMERA_REPORT_CREATE,
    PermissionEnum.CAMERA_REPORT_UPDATE,
    PermissionEnum.CAMERA_REPORT_DELETE,

    PermissionEnum.CAMERA_IMAGE_READ,
    PermissionEnum.CAMERA_IMAGE_DOWNLOAD,
    PermissionEnum.CAMERA_IMAGE_SHARE,

    PermissionEnum.CAMERA_IMAGE_COMMENT_READ,
    PermissionEnum.CAMERA_IMAGE_COMMENT_CREATE,
    PermissionEnum.CAMERA_IMAGE_COMMENT_UPDATE,
    PermissionEnum.CAMERA_IMAGE_COMMENT_DELETE,
    // PermissionEnum.CAMERA_IMAGE_COMMENT_CLOSE,

    PermissionEnum.PRINTSHOT_READ,

    PermissionEnum.DOCUMENT_READ,
    PermissionEnum.DOCUMENT_CREATE,
    // PermissionEnum.DOCUMENT_UPDATE,
    // PermissionEnum.DOCUMENT_DELETE,

    PermissionEnum.PROJECT_LINK_READ,
    PermissionEnum.PROJECT_LINK_CREATE,
    PermissionEnum.PROJECT_LINK_UPDATE,
    // PermissionEnum.PROJECT_LINK_DELETE,

    PermissionEnum.AUTODESK_INTEGARTION_READ,
    PermissionEnum.AUTODESK_INTEGARTION_CREATE,
    PermissionEnum.AUTODESK_INTEGARTION_UPDATE,
    PermissionEnum.AUTODESK_INTEGARTION_DELETE,

    PermissionEnum.IFRAME_INTEGRATION_READ,
    PermissionEnum.IFRAME_INTEGRATION_CREATE,
    PermissionEnum.IFRAME_INTEGRATION_UPDATE,
    PermissionEnum.IFRAME_INTEGRATION_DELETE,

    PermissionEnum.PLUGINS_READ,
    // PermissionEnum.PLUGINS_WRITE,
    // PermissionEnum.PLUGINS_DELETE,

    PermissionEnum.SUPPORT_TICKET_READ,
    PermissionEnum.SUPPORT_TICKET_CREATE,
    PermissionEnum.SUPPORT_TICKET_UPDATE,
    // PermissionEnum.SUPPORT_TICKET_DELETE,

    PermissionEnum.CLIENT_READ,
    PermissionEnum.CLIENT_CREATE,
    PermissionEnum.CLIENT_UPDATE,

    PermissionEnum.STORAGE_INTEGRATION_READ,
    PermissionEnum.STORAGE_INTEGRATION_CREATE,
    PermissionEnum.STORAGE_INTEGRATION_UPDATE,
    PermissionEnum.STORAGE_INTEGRATION_DELETE,

    PermissionEnum.GRIDWALL_READ,
    PermissionEnum.GRIDWALL_REQUEST,
    PermissionEnum.GRIDWALL_CREATE,
    // PermissionEnum.GRIDWALL_UPDATE,
    // PermissionEnum.GRIDWALL_DELETE,

    // PermissionEnum.SOCIAL_SHARE_UPDATE,

    PermissionEnum.PUBLIC_INGESTION_API_READ,
    // PermissionEnum.PUBLIC_INGESTION_API_CREATE,
    // PermissionEnum.PUBLIC_INGESTION_API_UPDATE,
    // PermissionEnum.PUBLIC_INGESTION_API_DELETE,

    PermissionEnum.PUBLIC_API_READ,
    // PermissionEnum.PUBLIC_API_CREATE,
    // PermissionEnum.PUBLIC_API_UPDATE,
    // PermissionEnum.PUBLIC_API_DELETE,
];

export const VIEWER_PERMISSIONS = [
    PermissionEnum.PROJECT_READ,
    // PermissionEnum.PROJECT_WRITE,
    // PermissionEnum.PROJECT_DELETE,

    PermissionEnum.CAMERA_READ,
    // PermissionEnum.CAMERA_WRITE,
    // PermissionEnum.CAMERA_DELETE,

    PermissionEnum.CAMERA_CCTV_READ,
    // PermissionEnum.CAMERA_CCTV_WRITE,
    // PermissionEnum.CAMERA_CCTV_DELETE,

    PermissionEnum.DRONE_READ,
    // PermissionEnum.DRONE_WRITE,
    // PermissionEnum.DRONE_DELETE,
    // PermissionEnum.DRONE_SHARE,

    PermissionEnum.SITE_GALLERY_READ,
    // PermissionEnum.SITE_GALLERY_WRITE,
    // PermissionEnum.SITE_GALLERY_DELETE,
    // PermissionEnum.SITE_GALLERY_SHARE,

    PermissionEnum.USER_READ,
    // PermissionEnum.USER_WRITE,
    // PermissionEnum.USER_DELETE,

    PermissionEnum.USER_INVITATION_READ,
    // PermissionEnum.USER_INVITATION_WRITE,
    // PermissionEnum.USER_INVITATION_DELETE,

    PermissionEnum.LIVELAPSE_READ,
    // PermissionEnum.LIVELAPSE_WRITE,
    // PermissionEnum.LIVELAPSE_DELETE,

    PermissionEnum.MULTIIMAGE_READ,
    // PermissionEnum.MULTIIMAGE_WRITE,
    // PermissionEnum.MULTIIMAGE_DELETE,

    PermissionEnum.PROGRESSLINE_READ,
    // PermissionEnum.PROGRESSLINE_WRITE,
    // PermissionEnum.PROGRESSLINE_DELETE,

    PermissionEnum.CAMERA_COMPARE_READ,

    PermissionEnum.PROGRESS_SLIDER_READ,

    PermissionEnum.CAMERA_INTEGRATION_READ,
    // PermissionEnum.CAMERA_INTEGRATION_WRITE,
    // PermissionEnum.CAMERA_INTEGRATION_DELETE,

    // PermissionEnum.CAMERA_REPORT_READ,
    // PermissionEnum.CAMERA_REPORT_WRITE,
    // PermissionEnum.CAMERA_REPORT_DELETE,

    PermissionEnum.AUTODESK_INTEGARTION_READ,
    // PermissionEnum.AUTODESK_INTEGARTION_CREATE,
    // PermissionEnum.AUTODESK_INTEGARTION_UPDATE,
    // PermissionEnum.AUTODESK_INTEGARTION_DELETE,

    PermissionEnum.IFRAME_INTEGRATION_READ,
    // PermissionEnum.IFRAME_INTEGRATION_CREATE,
    // PermissionEnum.IFRAME_INTEGRATION_UPDATE,
    // PermissionEnum.IFRAME_INTEGRATION_DELETE,

    PermissionEnum.CAMERA_IMAGE_READ,
    // PermissionEnum.CAMERA_IMAGE_SHARE,

    PermissionEnum.CAMERA_IMAGE_COMMENT_READ,
    // PermissionEnum.CAMERA_IMAGE_COMMENT_WRITE,
    // PermissionEnum.CAMERA_IMAGE_COMMENT_DELETE,
    // PermissionEnum.CAMERA_IMAGE_COMMENT_CLOSE,

    // PermissionEnum.PRINTSHOT_READ,

    PermissionEnum.DOCUMENT_READ,
    // PermissionEnum.DOCUMENT_WRITE,
    // PermissionEnum.DOCUMENT_DELETE,

    PermissionEnum.PROJECT_LINK_READ,
    // PermissionEnum.PROJECT_LINK_CREATE,
    // PermissionEnum.PROJECT_LINK_UPDATE,
    // PermissionEnum.PROJECT_LINK_DELETE,

    PermissionEnum.PLUGINS_READ,
    PermissionEnum.PLUGINS_CREATE,
    PermissionEnum.PLUGINS_UPDATE,
    PermissionEnum.PLUGINS_DELETE,

    // PermissionEnum.SUPPORT_TICKET_READ,
    // PermissionEnum.SUPPORT_TICKET_WRITE,
    // PermissionEnum.SUPPORT_TICKET_DELETE,

    // PermissionEnum.CLIENT_READ,
    // PermissionEnum.CLIENT_WRITE,

    PermissionEnum.STORAGE_INTEGRATION_READ,

    // PermissionEnum.SOCIAL_SHARE_UPDATE,

    // PermissionEnum.GRIDWALL_READ,

    PermissionEnum.PUBLIC_INGESTION_API_READ,
    // PermissionEnum.PUBLIC_INGESTION_API_CREATE,
    // PermissionEnum.PUBLIC_INGESTION_API_UPDATE,
    // PermissionEnum.PUBLIC_INGESTION_API_DELETE,

    PermissionEnum.PUBLIC_API_READ,
    // PermissionEnum.PUBLIC_API_CREATE,
    // PermissionEnum.PUBLIC_API_UPDATE,
    // PermissionEnum.PUBLIC_API_DELETE,
];

export const PermissionMap = {
    [UserRoleEnum.ADMIN]: ADMIN_PERMISSIONS,
    [UserRoleEnum.EDITOR]: EDITOR_PERMISSIONS,
    [UserRoleEnum.VIEWER]: VIEWER_PERMISSIONS,
};
